import { API_URL } from "../utils";

export default async (email: string): Promise<boolean> => {
	const request = await fetch(`${API_URL}/settings/email?set=${email}`, {
		credentials: 'include'
	});

	const jsonRequest = await request.json();

	return jsonRequest;
}
